var OCS = OCS || {};
OCS.Worker = OCS.Worker || {};
OCS.Worker.Classes = OCS.Worker.Classes || {};
OCS.Worker.Classes.NexradLevel3ParserWorker = new Class({
    Implements: [Options, Events],
    radar_files_process: 0,
    bound_methods: {},
    completetimout: null,
    destroytimeout: null,
    options: {
        time_to_destroy: 5000
    },
    initialize: function (op) {
        if (op) {
            this.setOptions(op);
        }
        this.bound_methods.process = this.process.bind(this);
        this.bound_methods.destroy = this.destroy.bind(this);
        var thread = OCS.Worker.Functions.get_processor();
        thread.addEvent('command', this.bound_methods.process);
        thread.addEvent('destroy', this.bound_methods.destroy);
        // Keep it active for a limited amount of time as we wait for the data to arrive
        if (this.options.time_to_destroy) {
            this.destroytimeout = setTimeout(this.destroy.bind(this), this.options.time_to_destroy);
        }
    },
    process: function (ev) {
        if (ev.data && ev.data.cmd === "nexrad_parse") {
            var data = ev.data;
            if (this.destroytimeout) {
                clearTimeout(this.destroytimeout);
            }
            OCS.Worker.Functions.set_status('active');
            try {
                var nexrad = new OCS.Parsers.Classes.NexradLevel3(data.options.arraybuffer, data.options.json);
                nexrad.parse();
                this.radar_files_process++;
                OCS.Worker.Functions.send_to_main({cmd: 'data', options: {result: nexrad.parsed}, processed: this.radar_files_process});
                this.completetimout = setTimeout(this.complete.bind(this), 0);
            } catch (e) {
                this.destroytimeout = setTimeout(this.destroy.bind(this), this.options.time_to_destroy);
            }
        }
    },
    complete: function () {
        OCS.Worker.Functions.set_status('idle');
        if (this.completetimout) {
            clearTimeout(this.completetimout);
        }
        if (this.options.time_to_destroy) {
            this.destroytimeout = setTimeout(this.destroy.bind(this), this.options.time_to_destroy);
        }
    },
    destroy: function () {
        if (this.destroytimeout) {
            clearTimeout(this.destroytimeout);
            this.destroytimeout = null;
        }
        if (this.completetimout) {
            clearTimeout(this.completetimout);
        }
        this.removeEvents();
        var thread = OCS.Worker.Functions.get_processor();
        thread.removeEvent('command', this.bound_methods.process);
        thread.removeEvent('destroy', this.bound_methods.destroy);
        thread.destroy();
        this.bound_methods = {};
    }
});
